module.exports = __webpack_public_path__ + "static/23-091952e4b2605b72a8d341ed6d6573aa.jpg";